import moment from "moment";
import { memo } from "react";
import { Line } from "react-chartjs-2";
import { GROUP_BY_FILTER_FORMATS } from "../../../constants/Globals";
import { formatNumberWithCommas } from "../../../helpers/Commas";

const ReportsPerformanceLineChart = ({
  chartData,
  groupBy,
  selectedMetric1,
  selectedMetric2,
}) => {
  return (
    <Line
      height={250}
      options={{
        maintainAspectRatio: false,
        aspectRatio: 1,
        responsive: true,
        plugins: { legend: { display: false } },
        scales: {
          y: {
            position: "left",
            ticks: {
              callback: (label) => formatNumberWithCommas(label),
            },
          },
          y2: {
            position: "right", // Adding the second Y-axis to the right
            grid: {
              drawOnChartArea: false, // Avoid drawing grid lines on this axis
            },
            ticks: {
              callback: (label) => formatNumberWithCommas(label),
            },
          },
        },
      }}
      data={{
        labels: (chartData || []).map(({ date }) =>
          moment(date.substring(0, 10)).format(
            groupBy === "day"
              ? GROUP_BY_FILTER_FORMATS.DATE_FULL_MONTH
              : GROUP_BY_FILTER_FORMATS.MONTH
          )
        ),
        datasets: [
          {
            label: "",
            data: (chartData || []).map((row) => row[selectedMetric1]),
            borderColor: "#8A10BE",
            backgroundColor: "#8A10BE",
            yAxisID: "y", // Associate this dataset with the left Y-axis
          },
          {
            label: "",
            data: (chartData || []).map((row) => row[selectedMetric2]),
            borderColor: "#51DAAB",
            backgroundColor: "#51DAAB",
            yAxisID: "y2", // Associate this dataset with the right Y-axis
          },
        ],
      }}
    />
  );
};

export default memo(ReportsPerformanceLineChart);
